import { ADICIONAR_NOTA_FISCAL } from '../types'

export default function adicionarNotaFiscal (notaFiscal) {
  return {
    type: ADICIONAR_NOTA_FISCAL,
    payload: notaFiscal
  }
}
